import { render } from "./StaffSurveys.vue?vue&type=template&id=cf8f9488&scoped=true"
import script from "./StaffSurveys.vue?vue&type=script&lang=js"
export * from "./StaffSurveys.vue?vue&type=script&lang=js"

import "./StaffSurveys.vue?vue&type=style&index=0&id=cf8f9488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8f9488"]])

export default __exports__